import { useEffect, useState } from "react";
import { Loader2, PackageSearch } from "lucide-react";
import { api, formatMoney } from "@/lib/api";
import OrderStatusBadge from "@/components/OrderStatusBadge";

export default function OrdersSection() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/orders/my")
      .then(({ data }) => setOrders(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="orders-section">
      <h2 className="mb-1 text-xl font-bold text-slate-800">My Orders</h2>
      <p className="mb-4 text-sm text-slate-500">Track the status of your orders here.</p>

      {loading ? (
        <div className="flex justify-center py-16">
          <Loader2 className="h-6 w-6 animate-spin text-blue-500" />
        </div>
      ) : orders.length === 0 ? (
        <div className="flex flex-col items-center gap-2 py-16 text-center text-slate-400">
          <PackageSearch className="h-10 w-10" />
          <p className="text-sm">You haven't placed any orders yet.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div
              key={o.id}
              data-testid={`order-card-${o.id}`}
              className="rounded-xl border border-blue-100 bg-white p-4 shadow-sm"
            >
              <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 pb-3">
                <div>
                  <p className="text-sm font-semibold text-slate-800">
                    Order #{o.id.slice(-6).toUpperCase()}
                  </p>
                  <p className="text-xs text-slate-400">
                    {new Date(o.created_at).toLocaleString("en-IN")}
                  </p>
                </div>
                <OrderStatusBadge status={o.status} />
              </div>
              <div className="mt-3 space-y-1.5">
                {o.items.map((it, idx) => (
                  <div key={idx} className="flex justify-between text-sm text-slate-600">
                    <span>
                      {it.name}
                      {it.unit ? <span className="text-slate-400"> ({it.unit})</span> : null}{" "}
                      <span className="text-slate-400">× {it.qty}</span>
                    </span>
                    <span className="font-medium">
                      {formatMoney(it.line_total) || "—"}
                    </span>
                  </div>
                ))}
              </div>
              <div className="mt-3 flex justify-between border-t border-slate-100 pt-3 text-sm font-bold text-slate-800">
                <span>Total</span>
                <span className="text-blue-700">{formatMoney(o.total) || "—"}</span>
              </div>
              {o.note ? (
                <p className="mt-2 rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-500">
                  Note: {o.note}
                </p>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
